import { ELocale } from '@/i18n/localeEnum';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { BadgeColor } from '@/api/resort/types';

export const ChoiceBadge = ({
  locale,
  color,
  className,
} : {
  locale: ELocale,
  color?: BadgeColor
  className?: string,
}) => {
  const { t } = useOTSTranslation('common');

  const badgeColor = color || BadgeColor.Normal;

  switch (locale) {
    case ELocale.CS_CZ:
    case ELocale.DE_DE:
    case ELocale.EN_US:
    case ELocale.EN_GB:
    case ELocale.FR_FR:
    case ELocale.IT_IT:
    case ELocale.PL_PL:
    case ELocale.SK_SK:
      return (
        <img
          className={className}
          src={`/assets/resort/visitors-choice-${locale}${badgeColor}.svg`}
          alt={t('guide.home.heroTitle')}
        />
      );
    default:
      return null;
  }
};
